// extracted by mini-css-extract-plugin
export default {"sidebar":"w_bd","anchor":"w_bf"};